import React from 'react';
import StarIcon from '@material-ui/icons/Star';
import StarBorderIcon from '@material-ui/icons/StarBorder';
import StarHalfIcon from '@material-ui/icons/StarHalf';
const StarsComponent = ({ value, onClick }) => {
  const starIcon = () => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= value) {
        stars.push(
          <StarIcon
            style={{ color: '#fdcb00', cursor: typeof onClick === 'function' ? 'pointer' : 'unset' }}
            className="star-icon-review"
            onClick={typeof onClick === 'function' ? () => onClick(i) : null}
          />
        );
      } else if (i === Math.ceil(value)) {
        stars.push(
          <StarHalfIcon
            style={{ color: '#fdcb00', cursor: typeof onClick === 'function' ? 'pointer' : 'unset' }}
            className="star-icon-review"
            onClick={typeof onClick === 'function' ? () => onClick(i) : null}
          />
        );
      } else {
        stars.push(
          <StarBorderIcon
            style={{ color: '#fdcb00', cursor: typeof onClick === 'function' ? 'pointer' : 'unset' }}
            className="star-icon-review"
            onClick={typeof onClick === 'function' ? () => onClick(i) : null}
          />
        );
      }
    }
    return stars;
  };

  return <div className="book-review">{starIcon()}</div>;
};

export default StarsComponent;
